export const ja = {
  app: {
    stepCreate: 'オリジナルクイズを作成',
    stepShare: '友達を招待',
    stepPlay: 'プレイ',
    logoS: 'Sをタップ',
  },
  footer: {
    privacy: 'プライバシー',
    terms: '利用規約',
    refunds: '返金',
    support: 'サポート',
    pricing: '料金',
    x: 'X',
    instagram: 'Instagram',
  },
  billing: {
    title: 'プランと請求',
    subtitle: 'クイズへの参加は常に無料。もっとクイズを作るにはサブスクリプションが必要です。',
    planFree: 'Free',
    planBasic: 'Basic',
    planPremium: 'Premium',
    freeIncludes: 'お試しクイズ{n}回 — ずっと有効',
    quizzesPerMonth: '月{n}回のクイズ作成',
    perMonth: '/月',
    currentPlan: '現在のプラン',
    subscribe: '登録する',
    manage: 'サブスクリプションを管理',
    remainingMonthly: '今月の残りは{limit}回中{n}回',
    remainingFree: '無料枠の残りは{limit}回中{n}回',
    paymentSuccess: 'お支払いが完了しました！プランが有効になりました。',
    paymentActivating: 'お支払いを確認 — プランを有効化しています…',
    paymentCancelled: 'お支払いはキャンセルされました。請求はありません。',
    signInFirst: '登録するにはGoogleでサインインしてください。',
    checkoutError: '決済を開始できませんでした。もう一度お試しください。',
    backHome: 'ホームへ戻る',
    quotaExceededTitle: 'クイズの作成回数を使い切りました',
    quotaExceededBody: 'プランをアップグレードするとクイズを作り続けられます。ゲームへの参加は無料のままです。',
    seePlans: 'プランを見る',
    rematchQuotaExceeded: '同じクイズを再プレイしています — ホストの作成回数が上限に達しました。',
  },
  auth: {
    signInTitle: 'サインインしてクイズを作成',
    signInHint: 'アカウントが必要なのはホストだけです。ゲストは招待リンクから参加できます — サインイン不要。',
    signInGoogle: 'Google で続行',
    signInError: 'サインインに失敗しました。もう一度お試しください。',
    signedInAs: '{email} でサインイン中',
    signOut: 'サインアウト',
    downloadIosApp: 'iOSアプリをダウンロード',
    loading: '読み込み中…',
  },
  lang: {
    label: '言語',
    en: 'English',
    ru: 'Русский',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ja: '日本語',
    ar: 'العربية',
  },
  setup: {
    title: 'プレイする前にセットアップが必要です',
    step1: '.env.local.example を .env.local にコピー',
    step2: 'Supabase の URL と Anon Key を入力',
    step3: 'OpenAI API キーを追加',
    step4: 'Supabase SQL Editor で supabase/schema.sql を実行',
    step5: '開発サーバーを再起動',
  },
  create: {
    topic: 'テーマ',
    topicPlaceholder: '例：90年代アニメ、科学、サッカー',
    difficulty: '難易度',
    difficultyEasy: 'かんたん',
    difficultyMedium: 'ふつう',
    difficultyHard: 'むずかしい',
    questions: '問題数',
    modeTitle: 'ゲームモード',
    modeRegular: '正解は全員得点',
    modeRegularHint: 'すぐに回答できます。制限時間が終わるまで選択を変更でき、時間は短縮されません — 正解した全員が得点します。全員が回答した場合のみ早く終了します。',
    modeHardcore: '最初の正解のみ得点',
    modeHardcoreHint: '最初の正解だけが得点します。回答は送信した瞬間に確定 — 変更不可、音声は一発勝負です。回答は同期された時計で順位付けされるため、回線速度はほとんど影響しません。',
    answerTime: '回答時間（秒）',
    mcTitle: '多肢選択',
    mcHint: '1問4択 — 全員が選び、正解ごとに得点',
    cameraTitle: 'プレイヤーカメラ',
    cameraHint: 'オフ = 音声のみ（マイクは有効）。オン = 全員が映像を共有。',
    submit: 'クイズを作成',
    generating: '問題を生成中',
    errorEmptyTopic: 'テーマを入力してください。',
    errorGenerate: '問題の生成に失敗しました。',
    errorCreate: 'データベースでゲームを作成できませんでした。',
    errorGeneric: '問題が発生しました。',
    createdTitle: 'クイズを作成しました',
    createdHint: 'このリンクを最大5人の友達と共有し、クイズに参加してください。',
    shareLink: '共有リンク',
    copy: 'コピー',
    copied: 'コピーしました',
    enterQuiz: 'クイズに参加',
    adjustShow: 'その他',
    adjustHide: '隠す',
    browseOpenGames: '公開ゲームを探す',
    browseOpenGamesHint: 'プレイヤー募集中のクイズに参加',
    inviteOnlyTitle: 'リンク限定',
    inviteOnlyHintOn: 'リンクを持つ人だけが参加できます。公開リストには出ません。',
    inviteOnlyHintOff: '開始するまで公開ゲーム一覧に表示されます。',
  },
  rooms: {
    title: '公開ゲーム',
    empty: '今は公開ゲームがありません。',
    refresh: '更新',
    join: '参加',
    back: '戻る',
    loading: '読み込み中…',
    error: '公開ゲームを読み込めませんでした。',
    players: '{n}/{max}',
    agoMinutes: '{n}分前',
    agoHours: '{n}時間前',
    agoJustNow: 'たった今',
    modeRegular: '正解はすべて加点',
    modeHardcore: '最初の正解のみ',
    mc: '選択式',
    voice: '音声',
  },
  join: {
    title: 'クイズに参加',
    hostTitle: 'あなたがホストです',
    subtitle: 'スコアが見えるように名前を選んでください。',
    namePlaceholder: 'あなたの名前',
    button: '参加',
    joining: '参加中…',
    full: 'このゲームは満員です（最大6人）。',
    errorEmptyName: '名前を入力してください。',
    banned: 'このゲームには再参加できません。',
  },
  lobby: {
    title: 'ロビー',
    players: 'プレイヤー',
    playersCount: '{n} / {max} 人',
    you: 'あなた',
    host: 'ホスト',
    shareInvite: 'このリンクを共有してプレイヤーを招待（合計最大6人）',
    waitingHost: 'ホストの開始を待っています…',
    needMore: 'あと1人以上の参加を待っています…',
    start: 'クイズを開始',
    removePlayer: '退出させる',
    removeConfirm: '{name} をこのゲームから退出させますか？',
    removeConfirmYes: '退出させる',
    removeConfirmNo: 'キャンセル',
    removeError: 'プレイヤーを退出させられませんでした。',
    listedPublicly: '開始するまで一覧に表示されます。',
  },
  game: {
    joining: 'ゲームに参加中',
    notFound: 'ゲームが見つかりません',
    notFoundHint: 'リンクを確認して再試行してください。ホストの場合は新しいゲームを作成してください。',
    backHome: 'ホームに戻る',
    removedTitle: '退出させられました',
    removedBody: 'ホストがあなたをこのゲームから退出させました。',
    removedHome: 'ホームに戻る',
    host: 'ホスト',
    guest: 'ゲスト',
    live: 'ライブ',
    offline: 'オフライン',
    waitingCamera: 'カメラ待機中',
    cameraErrorPermission: 'カメラ/マイクが拒否されています。このサイトを許可してからここをタップ。',
    cameraErrorInsecure: 'カメラには安全なリンク（HTTPS）が必要です。',
    cameraErrorNotFound: 'カメラまたはマイクが見つかりません。タップして再試行。',
    cameraErrorBusy: 'カメラ/マイクは別のアプリが使用中です。タップして再試行。',
    cameraErrorUnknown: 'カメラ/マイクにアクセスできません。タップして再試行。',
    cameraErrorTap: 'タップして許可',
    answering: '回答中',
    topic: 'テーマ',
    question: '問題',
    stealChance: 'スティールチャンス',
    getReady: '準備してください',
    thinkHint: '問題を読んでください — 回答は両者同時に解除されます',
    answerNow: '今すぐ回答',
    tileAnswered: '回答済み',
    tileThinking: '考え中…',
    youAnswering: 'あなたが回答中',
    listeningAnswer: '回答を聞いています',
    checkingAnswer: '回答を確認中',
    speakNow: '今すぐ話す',
    theySpeaking: '相手が話しています',
    secondsLeft: '残り{n}秒',
    opponentSteal: '相手がスティールできます',
    liveAnswer: 'ライブ回答',
    correctAnswer: '正解',
    speakAnswerNow: '今すぐ回答を話してください',
    speakHint: '両者が声に出して回答 — 最初の正解が勝ち',
    yourAnswer: 'あなたの回答',
    startSpeaking: '回答を話し始めてください…',
    holdToAnswer: '長押しして回答',
    recording: '録音中… 離すと送信',
    listening: '聞き取り中…',
    holdHint: 'ボタンを押しながら回答を話してください',
    saidNothing: '無回答',
    done: '完了',
    doneOptional: '今すぐ確定（任意）',
    autoSubmitHint: '話した回答は自動保存されます — ボタンを押す必要はありません。',
    answerLockedIn: '回答を確定しました',
    waitingOpponent: '相手を待っています…',
    typeYourAnswer: '下に回答を入力',
    typePlaceholder: 'またはここに回答を入力',
    waitShareLink: '相手にリンクを共有して開始',
    waitHostStart: 'ホストの開始を待っています',
    bothIn: '両プレイヤーが参加済み',
    questionsCount: '{n}問',
    modeMc: '多肢選択',
    modeVoice: '声で回答',
    startQuiz: 'クイズを開始',
    youreIn: '参加しました',
    waitHostStartOverlay: 'ホストの開始を待っています',
    waitOpponent: '相手の参加を待っています',
    connecting: 'ゲームに接続中',
    pointsMultiplier: '(×{n})',
  },
  buzz: {
    label: 'バズ',
    tapFirst: 'タップして最初に回答',
    youBuzzed: 'バズしました。話し始めてください',
    otherAnswering: '相手が回答中',
    ariaBuzz: 'バズして回答',
    ariaDisabled: 'バズは利用できません',
  },
  diag: {
    connected: '接続済み',
    connecting: '接続中…',
    micOff: 'マイクが検出されません',
    micStalled: '音声が届いていません',
    micActive: 'マイク有効',
    micIdle: 'マイクミュート',
    cameraOff: 'カメラなし',
  },
  ptt: {
    hold: '長押しで話す',
    talking: '話し中…',
    answerLive: 'マイクオン',
  },
  mc: {
    opponentSteal: '相手がスティールできます',
    answerLocked: '回答を確定しました',
    canChange: 'まだ変更できます',
    someoneAnswered: '誰かが回答しました — 残り{n}秒！',
    you: 'あなた',
  },
  score: {
    vs: 'VS',
    streak: '{n}連続',
    leaderboard: 'スコア',
    points: 'pt',
  },
  winner: {
    result: '結果',
    winner: '勝者',
    winners: '勝者',
    tie: '引き分け',
    finalScores: '最終スコア',
    downloadClips: '回答クリップをダウンロード',
    clipLabel: 'Q{n} · {role}の回答',
    download: 'ダウンロード',
    rematch: '再戦',
    rematchWaiting: '他のプレイヤーを待っています…',
    waitRematch: 'ホストの再戦開始を待っています',
    exit: '終了',
    discuss: '結果を話そう — 通話はあと{n}秒で終了',
    discussHint: 'カメラとマイクをオフにしました。再戦で再度通話できます。',
  },
} as const;
